import { render, staticRenderFns } from "./LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport.vue?vue&type=template&id=ea34b4de&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports